import React, { Fragment, useEffect, useState } from 'react';
import {
	add2ActiveFormPanel, mrbgStore, selectTagValue, setHideInp, setSundryField
} from './mrbgRedux/index.js';
import {mrbgTools} from "../../mrbgLib/mrbgTools.js";
import MrbgScrollFrame from './MrbgScrollFrame.jsx';
import mrbgS2S from '../../mrbgLib/mrbgS2S.js'
import chartStyle from '../../static/css/MP_charts.module.css';

function MrbgTimeLine({id,title,guideText,reqDate}){

	const
		[finalInfo, setFinalInfo] = useState(mrbgStore.getState().mrbgVars[id]||{}),
		[chartInfo, setChartInfo] = useState(mrbgStore.getState().mrbgVars[id]?.chartInfo||{} ),
		[requestDate,setRequestDate] = useState(),
		today = new Date().toLocaleString('fa-IR-u-nu-latn', {timeZone:'Asia/Tehran', year:'numeric', month:'2-digit', day:'2-digit'}).replace(',', '');

	useEffect(() => {
		const unsubscribe = mrbgStore.subscribe(() => {
			setFinalInfo( mrbgStore.getState().mrbgVars[id]||{} );
			setChartInfo( mrbgStore.getState().mrbgVars[id]?.chartInfo||{} );
			if( id==='specialDate__TL' )
				setRequestDate( new Date(mrbgStore.getState().formsSettings.specialDate?.sundryField?.beginDateTime).toLocaleString('fa-IR-u-nu-latn', {timeZone:'Asia/Tehran', year:'numeric', month:'2-digit', day:'2-digit'}).replace(',', '') )
		});

		return () => unsubscribe();
	}, [id]);

	return (
		<div className={chartStyle.timeLineFrame}>
			{
				title?
					<div className={chartStyle.MP_frameH2}>
						<h2>{title}</h2>
					</div>:
					''
			}
			{
				Object.keys(chartInfo).length?
					<>
						<div className={chartStyle.timeLine}>
							<table className={chartStyle.rightTbl}>
								<tbody>
								{
									Object.keys(chartInfo).map(date => {
										const
											dDate = new Date(date).toLocaleString('fa-IR-u-nu-latn', {timeZone:'Asia/Tehran', year:'numeric', month:'2-digit', day:'2-digit'}).replace(',', ''),
											dName = new Date(date).toLocaleDateString('fa-IR', { weekday: 'long' });
										return Object.keys(chartInfo[date]).map(( deviceName, j ) => {
											return(
												<tr className={chartStyle.rightTblTr} key={j}>
													{
														j===0?
															<th className={`${chartStyle.rightTblTh}${dDate===today? ' '+chartStyle.today:dDate===requestDate||dDate===reqDate? ' '+chartStyle.reqDate:''}${chartInfo[date][deviceName].dayInfo.holiday? ' '+chartStyle.holiday:''}`} rowSpan={Object.keys(chartInfo[date]).length}>
																<span>{dDate===today? 'امروز':dName}</span>
																<span>{dDate}</span>
															</th>:
															''
													}
													<>
														<td className={chartStyle.rightTblDevName}>{deviceName}</td>
														<td className={chartStyle.rightTblTd}>
															<ul className={chartStyle.rightTblDevTimeReport}>
																<li>
																	<span className={chartStyle.busySpan}></span> {chartInfo[date][deviceName].dayInfo?.sumBusy/60} دقیقه
																</li>
																<li>
																	<span className={chartStyle.gapSpan}></span> {chartInfo[date][deviceName].dayInfo?.sumGap/60} دقیقه
																</li>
																<li>
																	<span className={chartStyle.conflictSpan}></span> {chartInfo[date][deviceName].dayInfo?.sumConflict/60} دقیقه
																</li>
															</ul>
														</td>
													</>
												</tr>
											)
										})
									})
								}
								</tbody>
							</table>
							<MrbgScrollFrame properties={{className:chartStyle.leftCol}}>
								<TimeList {...finalInfo.timeLineInfo}/>
								<div className={chartStyle.periodsListFrame}>
									{
										Object.keys(chartInfo).map(date =>{
											return Object.keys(chartInfo[date]).map(( deviceName, k ) =>{
												return <DeviceList key={k} {...{periods:chartInfo[date][deviceName].sessionsInfo,dayWidthPx:chartInfo[date][deviceName].dayInfo.dayWidthPx,dayRightGapPx:chartInfo[date][deviceName].dayInfo.dayRightGapPx,deviceName}}/>
											})
										})
									}
								</div>
							</MrbgScrollFrame>
						</div>
						<div className={chartStyle.HC_guide}>
							<h3>راهنمای نمودار</h3>
							<ul className={chartStyle.flexRow}>
								<li>
									<span className={chartStyle.busySpan}></span> تایم‌های پر
								</li>
								<li>
									<span className={chartStyle.gapSpan}></span> تایم‌های خالی
								</li>
								<li>
									<span className={chartStyle.conflictSpan}></span> تداخل چند نوبت
								</li>
								<li>
									<span className={chartStyle.betweenSpan}></span> بین نوبتی
								</li>
								<li>
									<span className={chartStyle.overTimeSpan}></span>اضافه کاری
								</li>
							</ul>
						</div>
					</>:
					guideText?
						<div className={chartStyle.emptyTimeLineText}>{guideText}</div>:
						''
			}
		</div>
	);
}
function DeviceList({periods,dayWidthPx,dayRightGapPx,deviceName}){

	var index = {
		busy: 0,
		overTime: 0,
		between: 0
	};

	function handleGapClick( periodInfo ){
		var formID, bdtName, devName;
		if( mrbgStore.getState().activeForms.includes('apoResUpdFrame') ){
			formID  = 'apoResUpd';
			bdtName = 'beginDateTime';
			devName = 'devID';
		}
		else{
			formID = 'apoRes';
			bdtName = 'beginDateTime[0]';
			devName = 'devID[0]';
			mrbgStore.dispatch(add2ActiveFormPanel(`${formID}Frame`));
		}
		setTimeout(()=>{
			var
				myForm = document.getElementByDataID(formID),
				devID = mrbgStore.getState().mrbgVars.dev__ST;
			const timer = setTimeout( () => {
				devID = Object.keys(devID).find(k=>devID[k]===deviceName);
				window.scrollTo( 0,myForm?.getBoundingClientRect().top+window.scrollY-65 )
				mrbgTools.triggerChange( myForm.querySelector('input[name="'+bdtName+'"]'), periodInfo.start );
				if( myForm?.querySelector('input[name="'+devName+'"][value="'+devID+'"]') )
					myForm.querySelector('input[name="'+devName+'"][value="'+devID+'"]').checked = true;
				clearTimeout(timer)
			},0 )
		},0)
	}
	function handleEditClick( apoSesID ){
		var MD = new FormData();
		MD.append('id',apoSesID);
		mrbgS2S(null, MD, 'gDt','apoSes')
	}
	function readyForUpdateDate(periodInfo){
		console.log(periodInfo)
		if( !mrbgStore.getState().formsSettings?.timeLineUpd_DT )
			return;
		var devID = mrbgStore.getState().mrbgVars.dev__ST;
		mrbgStore.dispatch(setHideInp({formID:'timeLineUpd_DT',fieldName:'id',fieldValue:periodInfo.id}))
		mrbgStore.dispatch(setSundryField({formID:'timeLineUpd_DT',fieldName:'beginDateTime',fieldValue:periodInfo.start}))
		mrbgStore.dispatch(setSundryField({formID:'timeLineUpd_DT',fieldName:'devID',fieldValue:Object.keys(devID).find(k=>devID[k]===deviceName)}))
	}
	function handleTooltipPosition(e){
		var
			tooltip = e.target.querySelector(`.${chartStyle.TL_tooltipFrame}`),
			leftCol = e.target.closest(`.${chartStyle.leftCol}`),
			tooltipPos = tooltip.getBoundingClientRect(),
			leftColPos = leftCol.getBoundingClientRect(),
			overflowGap;

		if( tooltipPos.left+tooltipPos.width > leftColPos.left+leftColPos.width ){
			overflowGap = tooltipPos.left+tooltipPos.width-(leftColPos.left+leftColPos.width);
			tooltip.querySelector(':scope>div').style.transform = `translateX(${overflowGap*-1}px)`
		}
		else if( tooltipPos.left < leftColPos.left ){
			overflowGap = tooltipPos.left-leftColPos.left;
			tooltip.querySelector(':scope>div').style.transform = `translateX(${overflowGap*-1}px)`
		}
	}

	return (
		<ul className={chartStyle.periodsList} style={{width:`${dayWidthPx}px`,right:`${dayRightGapPx}px`}}>
			{
				periods?.map(( prd, i ) => {
					var
						start = new Date(`${prd.start.replace(' ', 'T')}Z`).toLocaleString('fa-IR-u-nu-latn', {
							timeZone: 'Asia/Tehran',
							hour: '2-digit',
							minute: '2-digit'
						}).replace(',', ''),
						end   = new Date(`${prd.end  .replace(' ', 'T')}Z`).toLocaleString('fa-IR-u-nu-latn', {
							timeZone: 'Asia/Tehran',
							hour: '2-digit',
							minute: '2-digit'
						}).replace(',', '');

					if( prd.type=='conflict' )
						return(
							<li className={chartStyle.conflictCell} style={{width:`${prd.widthPx}px`,right:`${prd.rightPx}px`}} onMouseEnter={e=>handleTooltipPosition(e)} key={i}>
								<div className={chartStyle.TL_tooltipFrame}>
									<div className={chartStyle.TL_tooltip}>
										<div className={chartStyle.TLT_time}>{`${start} - ${end}`}</div>
										<div>{`${prd.widthPx/2} دقیقه تداخل زمانی ${prd.title}`}</div>
									</div>
								</div>
							</li>
						)

					else if( prd.type=='gap' )
						return(
							<li className={`${chartStyle.gapCell} ${prd.suitable? chartStyle.suitableGap: ''}`} style={{width:`${prd.widthPx}px`,right:`${prd.rightPx}px`}} onClick={()=>handleGapClick(prd)} key={`${i}d`}>
								<div className={chartStyle.TL_tooltipFrame}>
									<div className={chartStyle.TL_tooltip}>
										<div className={chartStyle.TLT_time}>{`${start} - ${end}`}</div>
										<div>{`${prd.duration} زمان`}</div>
									</div>
								</div>
							</li>
						)

					else{
						let className = [chartStyle[`${prd.type}Cell`]];
						if( index[prd.type]++ % 2 ){
							className.push(chartStyle.even)
						}
						if( prd.bookingStatus==='رزرو' )
							className.push( chartStyle.reserveCell )

						let type ='';
						if( prd.type==='between' )
							type = <span className={chartStyle.TLT_type}>(بین نوبتی)</span>;
						else if( prd.type==='overTime' )
							type = <span className={chartStyle.TLT_type}>(اضافه کاری)</span>;

						return(
							<li className={className.join(' ')} style={{width:`${prd.widthPx}px`,right:`${prd.rightPx}px`}} onMouseEnter={e=>handleTooltipPosition(e)} onClick={()=>navigator.clipboard.writeText(prd.code)} key={`${i}d`}>
								<div className={chartStyle.TL_tooltipFrame}>
									<div className={chartStyle.TL_tooltip}>
										<div>
											{prd.bookingStatus}
											<span className={chartStyle.TLT_time}>{`${start} - ${end}`}</span> {type}
											<i className="fa-regular fa-pen" onClick={()=>handleEditClick(prd.id)} key={`${i}TE`}></i>
											<i className="fa-regular fa-calendar" onClick={()=>readyForUpdateDate(prd)} key={`${i}DE`}></i>
										</div>
										<div>{prd.areName}</div>
										<div>{`${prd.gender} ${prd.fullName}`}</div>
									</div>
								</div>
							</li>
						)
					}
				})
			}
		</ul>
	)
}
function TimeList( {startTime,endTime} ){

	const hoursList = [];

	for( let sec = startTime; sec<=endTime; sec += 3600 ){
		const display = new Date(sec*1000).toLocaleString('fa-IR-u-nu-latn', {timeZone:'Asia/Tehran', hour:'2-digit', minute:'2-digit'}).replace(',', '');
		hoursList.push(display);
	}

	return (
		<ul className={chartStyle.timeList}>
			{
				hoursList.map(( h, i ) => (
					<li key={i}>{h}</li>
				))
			}
		</ul>
	);
}
export default MrbgTimeLine;